import { render, staticRenderFns } from "./RxTable.vue?vue&type=template&id=5a740a09"
import script from "./RxTable.vue?vue&type=script&lang=js"
export * from "./RxTable.vue?vue&type=script&lang=js"
import style0 from "./RxTable.vue?vue&type=style&index=0&id=5a740a09&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports